(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGORender"), require("FEGOWebapi"), require("FEGOBridge"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGORender", "FEGOWebapi", "FEGOBridge"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/fixed-box/render"] = factory(require("VueDemi"), require("FEGORender"), require("FEGOWebapi"), require("FEGOBridge"));
	else
		root["/fego/component/fixed-box/render"] = factory(root["VueDemi"], root["FEGORender"], root["FEGOWebapi"], root["FEGOBridge"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__2309__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__7145__) => {
return 